import type { ShopCapability } from "@hobbyshopify/backend-client";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CapabilityRequestPanel } from "../../sections/capability-request/capability-request";
import { CapabilityGateController } from "./capability-gate-controller";

export function CapabilityGateRoute({ deps, capability }: { deps: AppDeps; capability: ShopCapability }) {
  return (
    <Subtree
      key="capability-gate"
      deps={[capability]}
      controller={() =>
        new CapabilityGateController(
          pick(deps, "client", "authHandler", "storeRepository", "capabilitiesRepository"),
          capability,
        )
      }
    >
      <CapabilityRequestPanel />
    </Subtree>
  );
}
